// ValidationRoute.jsx
import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export default function ValidationRoute({ children }) {
  const token = localStorage.getItem("token"); // Change key if yours is different
  const location = useLocation(); 

  // useEffect(() => {
  //   if (!token) {
  //     navigate('/login');
  //   }
  // }, []);
  // If token is missing and not already on /login, redirect to login
  if (token == "") {
    return <Navigate to="/login" state={{ fromGuest: true }} replace />;
  }

  // Otherwise, render children (the protected routes)
  return children;
}
